import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";
import { Layout } from "components/common";
import Footer from "components/Footer/Footer";
import { Header, SideBar } from "components/modules/Portal";
import PortalRoutes from "routes/portal/PortalRoutes";
import { useStyles } from "./layoutStyles";
import {
  AUTH_ROOT_ROUTE,
  PHONE_VERIFICATION_ROUTE,
} from "routes/auth/authPaths";
import useAuthentication from "hooks/useAuthentication";

const Portal = () => {
  const classes = useStyles();
  const history = useHistory();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { userDataIsLoaded, isPhoneVerified } = useSelector(({ auth }) => ({
    userDataIsLoaded: !!(auth.isAuthenticated && auth.user.id),
    isPhoneVerified: !!(auth.isAuthenticated && auth.user.verifiedPhone),
  }));

  useAuthentication();

  useEffect(() => {
    if (userDataIsLoaded && !isPhoneVerified) {
      history.push(AUTH_ROOT_ROUTE + PHONE_VERIFICATION_ROUTE);
    }
  }, [userDataIsLoaded, isPhoneVerified, history]);

  return userDataIsLoaded ? (
    <Layout
      header={
        <Header
          isSidebarOpen={isSidebarOpen}
          onToggleSidebar={() => {
            setIsSidebarOpen(!isSidebarOpen);
          }}
        />
      }
      sidebar={
        <SideBar
          onClose={() => {
            setIsSidebarOpen(false);
          }}
          isSidebarOpen={isSidebarOpen}
        />
      }
      content={<PortalRoutes />}
      footer={<Footer />}
    />
  ) : (
    <CircularProgress className={classes.loading} />
  );
};

export default Portal;
